/*
 * 订单确认
 * */
import request from "@utils/request";

/**
 * 通过购物车 id 获取订单信息
 * @param cartId
 * @returns {*}
 */
export function postOrderConfirm(data) {
  return request({
    url: "Order/confirm",
    method: "post",
    data
  });
}

/**
 * 购买成功之后，获取群二维码
 * @returns {AxiosPromise}
 */
export function getQrImg() {
  return request({
    url: "Order/getQrCode"
  });
}

/**
 * 获取自提货的店铺id
 */
export function getShop() {
  return request({
    url: "Order/getShop"
  });
}

export function getBuyPop() {
  return request({
    url: "Order/getBuyPop"
  });
}

/**
 * 计算订单金额
 * @param key
 * @param data
 * @returns {*}
 */
export function postOrderComputed(data) {
  return request({
    url: "Order/computedPrice",
    method: "post",
    data
  });
}

/**
 * 生成订单
 * @param key
 * @param data
 * @returns {*}
 */
export function createOrder(data) {
  return request({
    url: "Order/createOrder",
    method: "post",
    data
  });
}

/**
 * 订单统计数据
 * @returns {*}
 */
export function getOrderData() {
  return request({
    url: "Order/getStatusCount"
  });
}

/**
 * 订单列表
 * @returns {*}
 */
export function getOrderList(data) {
  return request({
    url: "Order/getList",
    method: "post",
    data
  });
}

/**
 * 取消订单
 * @returns {*}
 */
export function cancelOrder(params) {
  return request({
    url: "Order/cancel",
    params
  });
}

/**
 * 订单详情
 * @returns {*}
 */
export function orderDetail(params) {
  return request({
    url: "Order/detail",
    params
  });
}

/**
 * 获取用户买一赠一权益
 * @param data
 */

export function getGiftList(data) {
  return request({
    url: "Order/getGiftList",
    method: "post",
    data
  });
}

/**
 * 退款理由
 * @returns {*}
 */
export function getRefundReason() {
  return request.get("/order/refund/reason");
}

/**
 * 退货
 * @param data
 * @returns {Promise<AxiosResponse<any>>}
 */
export function returnOfGoods(data) {
  return request.post("Order/refund", data);
}

/**
 * 提交退款
 * @returns {*}
 */
export function postOrderRefund(data) {
  return request.post("/order/refund/verify", data);
}

/**
 * 确认收货
 * @returns {*}
 */
export function takeOrder(uni) {
  return request.post("/order/take", { uni });
}

/**
 * 删除订单
 * @returns {*}
 */
export function delOrder(uni) {
  return request.post("/order/del", { uni });
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function express(uni) {
  return request.get("order/express/" + uni);
}

/**
 * 订单查询物流信息
 * @returns {*}
 */
export function payOrder(id, pay_type, from) {
  let data = { id, pay_type, from };
  return request({
    url: "Order/pay",
    method: "post",
    data
  });
}
/**
 * 订单核销
 * @returns {*}
 */
export function orderVerific(verify_code, is_confirm) {
  return request.post("order/order_verific", { verify_code, is_confirm });
}
